// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block{padding:10px}.block1{background:#ff0}.block2{background:#7fd174}.middle_content{min-height:400px}", ""]);
// Exports
module.exports = exports;
